import { sampleClips } from "./sampleData.js";
export function getWorkplaceSample(staticAssetBaseUrls, themeId = "vintage-symmetry", themeVersion) {
    return {
        version: 1,
        occasionId: "workplace",
        themeId,
        themeVersion,
        staticAssetBaseUrls,
        videoFrame: {
            width: 1920,
            height: 1080,
            fps: 30,
        },
        introGreeting: {
            enabled: true,
            messages: [
                "Thank you for your hard work and dedication to our team. ❤️",
                "We appreciate everything you do to make our workplace great.",
            ],
        },
        outroGreeting: {
            enabled: true,
            messages: ["Congratulations on your promotion, Emily!"],
        },
        faceCollageEnabled: true,
        userInput: {
            colorPicker: "Rust",
            titleMessage: "Congrats, Emily! 🎉",
        },
        music: {
            enabled: true,
            volumeDuringClips: "low",
            song: {
                id: "a-minor-waltz",
                name: "A Minor Waltz",
                duration: 140.329796,
                urls: [
                    "https://memento-sandbox-music.s3.us-east-2.amazonaws.com/A_Minor_Waltz.mp3",
                ],
            },
        },
        logo: {
            enabled: false,
            size: "medium",
            urls: [],
        },
        branding: {
            enabled: true,
        },
        clips: sampleClips,
    };
}
